import hcAxios, { AxiosResponse } from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'

export type TGetFuzzyInfoServiceResponse = TResponse<{
  email: string | null
  phone: string | null
  isOpenEmailValidate: boolean
  isOpenGoogleValidate: boolean
  isOpenPhoneValidate: boolean
}>

export type TGetFuzzyInfoServiceParams = {
  loginName: string
}

export const getFuzzyInfoService = async (params: TGetFuzzyInfoServiceParams) => {
  return await hcAxios.get<TGetFuzzyInfoServiceResponse>('/hk-web/getFuzzyInfo', { params })
}

export type TVerifyImage4LoginServiceParams = {
  address: string
  captchaOutput: string
  deviceModel?: string
  genTime: string
  lotNumber: string
  passToken: string
  pwd: string
  sceneId: string
}

export type TVerifyImage4LoginServiceResponse = TResponse<
  {
    status: number
    version?: string
  }[]
>

export const verifyImage4LoginService = (data: TVerifyImage4LoginServiceParams) => {
  return hcAxios.post<TVerifyImage4LoginServiceResponse>('/hk-web/v4/verifyImage4Login', data, {
    options: {
      signature: true,
      disableErrorCodeResponseHandler: true,
    },
  })
}

export type TUserinfo = {
  fid: number
  fshowid: any
  fintrocode: any
  floginname: string
  fnickname: string
  floginpassword: string
  ftradepassword: string
  ftelephone: any
  femail: string
  frealname: any
  country: string
  fidentityno: any
  fidentitytype: number
  fgoogleauthenticator: string
  fgoogleurl: string
  fstatus: number
  fhasrealvalidate: boolean
  fhasrealvalidatetime: any
  identityType: number
  identityStatus: number
  fistelephonebind: boolean
  fismailbind: boolean
  fgooglebind: boolean
  fupdatetime: number
  ftradepwdtime: any
  fareacode: any
  version: number
  fintrouid: any
  finvalidateintrocount: number
  fiscny: number
  fiscoin: number
  fbirth: any
  flastlogintime: number
  fregistertime: number
  fleverlock: number
  fqqopenid: any
  funionid: any
  fagentid: number
  flastip: string
  folduid: any
  fplatform: number
  isVideo: boolean
  videoTime: any
  isOpenPhoneValidate: boolean
  isOpenGoogleValidate: boolean
  isOpenEmailValidate: boolean
  photo: any
  photoAssetId: number
  isPhotoAction: any
  isHavedModNickname: boolean
  isSpotAction: any
  isOtcAction: boolean
  isActivateContract: boolean
  isActivateMargin: boolean
  isActivateDualInvest: boolean
  marginActivateDatetime: any
  remark: any
  type: number
  vipType: number
  vipLevel: number
  transferStatus: boolean
  zhNickname: any
  commonNickname: any
  modNicknameNum: any
  fstatus_s: string
  fiscny_s: string
  fiscoin_s: string
  fFavoriteTradeList: any
  tradeList: any[]
  canOpenOrepool: string
  ip: string
  score: number
  level: number
  loginTTL: number
  rcfailuretime: any
  isNftPhoto: boolean
  canOpenOtc: number
  openPhoneValidate: boolean
  openGoogleValidate: boolean
  openEmailValidate: boolean
  otcAction: boolean
  unrealFiatWithdraw: boolean
  vipName: string
  leveracctid: any
  isOpenLever: string
  lastLoginTimeStamp: any
  realIdentityType: number
}

export type TLoginServiceResponse = TResponse<
  {
    token: string
    contractToken: string
    refreshToken: any
    userinfo: TUserinfo
    secretKey: string
  }[]
>

enum validType {
  phone = 1,
  email = 2,
  google = 3,
}

export type TLoginServiceParams =
  | {
      address: string
      pwd: string
      validType: 0 // 第一次提交传0
    }
  | {
      address: string
      validType: validType
      pwd: string
      validCode: string
      imageCode: string
    }

export const loginService = (data: TLoginServiceParams) => {
  return hcAxios.post<TLoginServiceResponse>('/hk-web/v3/login', data, {
    options: {
      signature: true,
      disableErrorCodeResponseHandler: true,
    },
  })
}

export type TGetVerifyCodeServiceResponse = TResponse<
  {
    id: string
    code: string
    title: string
    content: any
    createdTime: number
  }[]
>

export enum TSendType {
  google = 0,
  phone = 1,
  email = 2,
}

export type TGetVerifyCodeServiceParams =
  | {
      businessType: 'login_v3' | 'reset_login_pwd' // 碰到了再补充
      sendType: TSendType
      address?: string
      seqNo?: number // 验证码发送次数
    }
  | {
      businessType: 'reset_login_pwd'
    }

export const getVerifyCodeService = (data: TGetVerifyCodeServiceParams) => {
  return hcAxios.post<TGetVerifyCodeServiceResponse>('/hk-web/v1/sendValidCode', data, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TGetBehaviorVerifyModelServiceResponse = TResponse<{
  behaviorVerifyType: 1 // todo: 待确认数字含义
  geeTest: {
    captchaId: string
  }
}>

export const getBehaviorVerifyModelService = (sceneId: string) => {
  return hcAxios.post<TGetBehaviorVerifyModelServiceResponse>(
    '/hk-web/v5/getBehaviorVerifyModel',
    {
      sceneId,
    },
    {
      options: {
        signature: 'decrypted',
      },
    }
  )
}
export type TGetSecretKeyServiceResponse = TResponse<string>

export type TGetSecretKeyParams = {
  randomKey: string
  randomIv: string
  bizData: string
  signature: string
  timestamp: number
}
export const getSecretKeyService = (params: TGetSecretKeyParams) => {
  return hcAxios.post<TGetSecretKeyServiceResponse>('/hk-web/gsip', params)
}

export type TGetUserInfoServiceResponse = TResponse<TUserinfo>

export const getUserInfoService = () => {
  return hcAxios.post<TGetUserInfoServiceResponse>('/hk-web/v2/getUserInfo')
}

export type TGetOneTradeInfoParams = {
  buyShortName: string
  sellShortName: string
  tradeId?: string
  type?: string
}

export type TGetOneTradeInfoResponse = {
  tradeId: number
  id: number
  buySymbol: string
  sellSymbol: string
  image: string
  sellShortName: string
  buyShortName: string
  p_new: number
  p_open: number
  total: number
  totalAmount: number
  buy: number
  sell: number
  rose: number
  cny: number
  digit: string
  type: number
  isOpen: string
  isFiatConvert: boolean
}

// 根据sellName和buyName获取交易对信息
export const getOneTradeInfo = async (params: TGetOneTradeInfoParams) => {
  return await hcAxios.get<TResponse<TGetOneTradeInfoResponse>>(`/hk-web/v2/getOneTradeInfo`, { params })
}

export type TGetFullDepthParams = {
  tradeId: string | number
}

export type TGetFullDepthResponse = TResponse<{
  last: string // 最新价
  asks: string[][] // 【卖方价格,卖方深度度量】
  bids: string[][] // 【买方价格,买方深度量】
  buyOrSellCnyPrice: string // 买入或者卖出人民币估值时使用
  isRiskTip: boolean
  usdtCnyPrice: number
  open: string // 开盘价
  cny: string // 折合人民币价格
}>

// 获取深度图数据
export const getFullDepth = async (params: TGetFullDepthParams) => {
  return await hcAxios.get<TGetFullDepthResponse>(`/hk-web/v3/fullDepth`, { params })
}

export type TGetCoinInfoParams = {
  shortName: string
}

export type TGetCoinInfoResponse = TResponse<{
  id: number
  coinId: number
  nameZh: string
  nameEn: string
  nameShort: string
  total: string
  price: string
  circulation: string
  algorithm: string | null
  blockVelocity: string | null
  blockSize: string | null
  ico: string | null
  icoPlatform: string | null
  linkWebsite: string
  linkWallet: string
  linkBlock: string
  linkWhitepaper: string
  officialQq: string | null
  officialWechat: string | null
  officialPhone: string | null
  info: string
  shortInfo: string | null
  lanName: string
  gmtRelease: string
  gmtCreate: string | null
  gmtModified: number
  version: string | null
  scene: string
  highlights: string
  maintenanceNotes: string
  rechargeWarnWord: string
  withdrawWarnWord: string
  lastPrice: number
  chg: number
  globalTurnover: string
  circulationRate: string
  marketValue: string
  logo: string
}>

// 获取单个币种信息
export const getCoinInfo = async (params: TGetCoinInfoParams) => {
  return await hcAxios.get<TGetCoinInfoResponse>(`/hk-web/v2/coin_info`, { params })
}
